export const SnackbarMutationTypes = {
  HIDE_SNACKBAR: "HIDE_SNACKBAR",
  SHOW_SNACKBAR: "SHOW_SNACKBAR"
};
